import './index.css';
import { isProxyFarmUa } from './lib/humanGate';

// 진입점은 일부러 가볍게 둔다(2026-10-03). 앱 본체(bootstrap.jsx → Firebase)를 동적 import로 떼어내,
// 프록시 팜 봇에게는 Firebase를 아예 띄우지 않는다. 그 봇은 실브라우저라 JS를 실행하고, 그대로 두면
// 익명 계정 생성·방문 기록·App Check·Firestore 피드 조회를 매번 일으켜 관리자 대시보드의 방문·신규를
// 부풀렸다(2026-10-03 오늘 방문 106명 중 33명). 판정 근거는 lib/humanGate.js isProxyFarmUa.
// 본체 청크(약 0.5MB gzip)도 내려받지 않으므로 Hosting 전송량도 같이 준다.
//
// 오탐 대비: 판정에 걸려도 사람이 화면을 실제로 누르거나 키를 치면(isTrusted) 그때 부팅한다.
// 30일 실측 오탐은 0이었지만, 걸렸을 때 영영 빈 화면이 되지 않게 하는 안전장치다.
// 'scroll'·'mousemove'는 쓰지 않는다 — 이 봇은 스크롤을 한다.
const BOOT_EVENTS = ['pointerdown', 'touchstart', 'keydown'];

function boot() {
  import('./bootstrap.jsx').catch((e) => {
    // 조용한 실패 금지 — 청크 로드 실패면 화면이 비므로 최소한 콘솔·Sentry가 잡도록 다시 던진다.
    console.error('[main] 앱 로드 실패:', e);
    throw e;
  });
}

if (isProxyFarmUa(navigator.userAgent)) {
  const onInput = (e) => {
    if (!e.isTrusted) return;
    for (const ev of BOOT_EVENTS) window.removeEventListener(ev, onInput, true);
    boot();
  };
  for (const ev of BOOT_EVENTS) window.addEventListener(ev, onInput, { capture: true, passive: true });
} else {
  boot();
}
